module.exports = "/static/Images/en/survey_no.png";